import React, { useState } from "react";

import { Modal } from "antd";

import api from "../../../services/api";
import { notifySucces, notifyError } from "../../../utils/notifications";
import * as S from "../style"
import { storageService } from "../../../services/storageService";


const ChangeClientCardModal = ({
  isVisible,
  onCancel,
  productId,
  client_id,
  cardNumber,
  cardId
}) => {
  const [isLoadingNewSolicitation, setIsLoadingNewSolicitation] = useState(false);

  const handleSolicitation = async () => {
    try {
      const identity = storageService.getIdentity();
      setIsLoadingNewSolicitation(true);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { data } = await api.patch('card_exchange', {
        identity,
        card_id: cardId,
        client_id,
        card_number: cardNumber,
        product_id: productId
      });
      notifySucces('Solicitado com sucesso');
    } catch (error) {
      notifyError(error.message);
    } finally {
      setIsLoadingNewSolicitation(false);
      onCancel();
    }
  }

  return (
    <Modal
      visible={isVisible}
      title={<span style={{ fontWeight: "bold" }}>Realizar troca de cartão</span>}
      onCancel={onCancel}
    >
        <S.WrapperSelectBlock>
          <button className="solicitate"
            type="button"
            onClick={handleSolicitation}
            disabled={isLoadingNewSolicitation}
            style={{
              cursor: (isLoadingNewSolicitation) ? "not-allowed" : "pointer",
              opacity: (isLoadingNewSolicitation) ? "0.8" : "1"
            }}>Solicitar</button>
        </S.WrapperSelectBlock>
    </Modal>
  );
}

export default ChangeClientCardModal;
